import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DocumentVersionList } from './DocumentVersionList';
/**
 * HistoryPanel Component
 * Displays the version history panel for artifacts
 * Pure presentation component - receives data from parent
 */ export const HistoryPanel = ({ selectedId, isOpen, isLoading, onVersionSelect })=>{
    if (!isOpen) {
        return null;
    }
    if (isLoading) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex-1 overflow-auto flex flex-col bg-background p-4",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse w-3/4"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse w-full"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse w-5/6"
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "flex-1 overflow-auto flex flex-col bg-background",
        children: selectedId ? /*#__PURE__*/ _jsx(DocumentVersionList, {
            artifactId: selectedId,
            onVersionSelect: onVersionSelect
        }) : /*#__PURE__*/ _jsx("div", {
            className: "text-sm text-muted-foreground py-4 px-3 text-center",
            children: "No artifact selected"
        })
    });
};
